module.exports = "/_next/static/images/green-sticker_en-1458725e498564a4eb28b27aa2684f3d.png";